(function() {
    'use strict';

    let VerificaUtenzaCtrl = function(
        $scope,
        $state,
        messaggiFctr,
        verificaUtenzaService,
        $uibModalInstance
    ) {
        this.utenze = [];
        this.loading = 0;
        this.listaErrori = [];

        this.init = () => {
            this.loading = (this.loading > 0) ? this.loading + 1 : 1;
            verificaUtenzaService
                .openLista()
                .then(
                    (res) => {
                        if (messaggiFctr.processaResponse(res) || !res.data.result) {
                            return;
                        }
                        let utenzeValide = res.data.result || [];
                        if (utenzeValide.length == 0) {
                            this.proseguiNavigazione();
                            return;
                        }
                        this.utenze = [];
                        utenzeValide.forEach((utenza) => {
                            this.utenze.push({
                                codice: utenza.codiceUtente,
                                stato: utenza.stato
                            });
                        });
                    },
                    (error) => {
                        messaggiFctr.processaResponse(error);
                        this.listaErrori.push(error.data);
                    }
                )
                .finally(() => {
                    this.loading--;
                });

            verificaUtenzaService
            .recuperaTuttiStati()
                .then(
                    (resp) => {
                        this.dominiStato = resp.data.result;
                    },
                    (error) => {
                        messaggiFctr.processaResponse(error);
                        this.listaErrori.push(error.data);
                    }
                );
        };

        this.proseguiNavigazione = () => {
            $state.go('collocamentoUtenteMito', {
                ndg: verificaUtenzaService.ndg,
                codiceProdotto: verificaUtenzaService.codiceProdotto
            });
            $uibModalInstance.close();
        };

        this.close = () => {
            $uibModalInstance.dismiss();
        };

        this.decodeStato = (stato) => {
            if (!this.dominiStato) {
                return '...';
            }
            let dominio = this.dominiStato.find((s) => s.codice === stato);
            return dominio ? dominio.descrizione : '';
        };

        this.utenzaCompleta = (s) => {
            return ['F', 'B'].includes(s.stato);
        };

        this.collocamentoMitoInibito = () => {
            let utenzeValide = this.utenze.filter((s) => !['F', 'B'].includes(s.stato)) || [];
            return utenzeValide.length > 0;
        };

        this.init();
    };

    VerificaUtenzaCtrl.$inject = [
        '$scope',
        '$state',
        'MitomMessaggiFctr',
        'MitomVerificaUtenzaService',
        '$uibModalInstance'
    ];

    angular
        .module('cbl.mitomanager.wa')
        .controller('MitomVerificaUtenzaController', VerificaUtenzaCtrl);
})();